import {
  ApolloClient,
  ApolloLink,
  HttpLink,
  InMemoryCache
} from '@apollo/client'
import { setContext } from '@apollo/client/link/context'
import Keycloak from 'keycloak-js'

export const initApollo = (uri: string, keycloak: Keycloak) => {
  const httpLink = new HttpLink({ uri })

  const authLink = setContext(async (_, { headers }) => {
    if (!keycloak.authenticated) {
      return { headers }
    }

    try {
      await keycloak.updateToken(5)
      return {
        headers: {
          ...headers,
          authorization: `Bearer ${keycloak.token}`
        }
      }
    } catch (error) {
      console.error('Apollo AuthLink: Failed to refresh token', error)
      return { headers }
    }
  })

  return new ApolloClient({
    link: ApolloLink.from([authLink, httpLink]),
    cache: new InMemoryCache(),
    devtools: { enabled: import.meta.env.VITE_PROFILE !== 'production' }
  })
}
